<template>
    <div>

        <PageTitle v-bind:title="title" v-bind:admin="false" />

        <TheCoursesMenu v-bind:index=2 />
        
        <!--
        <div class="section mt-4">
            <div class="row">
                <div class="col-lg-2">
                </div>
                <div class="col-lg-8">
                    <div class="card shadow p-3">
                        <div class="row">
                            <div class="col-2 d-flex">
                                <img src="/images/grapes.svg" class="rounded float-left" style="width: 100%;" alt="">
                            </div>
                            <div class="col-10">
                                Какая-нибудь мотивирующая надпись, или чья-нибудь цитата. Ну или что-нибудь ещё.
                            </div>           
                        </div>
                    </div>
                </div>
                <div class="col-lg-2">
                </div>
            </div>     
        </div>
        -->

        <QuoteTest />

        <h2 class="mt-4">Курсы в процессе прохождения</h2>

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>



        <Loader v-if="loading" />
        <div v-else class="card mt-3" v-for="c in data.courses" v-bind:key="c.id">
            <div class="card-header">
                <img src="/icons/marker.png" width="32px" alt="">
                Курс пройден на {{ Math.round(100 * c.chapters_finished_count / c.chapters_count) }}%
            </div>
            <div class="card-body">
                <h5 class="card-title">{{ c.name }}</h5>
                <p class="card-text">
                    <ul>
                        <li>Курс начат: <strong>{{ localeDate(c.pivot.started_at) }}</strong></li>
                        <li>Всего глав: <strong>{{ c.chapters_count }}</strong></li>
                        <li>Пройдено глав: <strong>{{ c.chapters_finished_count }}</strong></li>
                        <li v-if="c.next_chapter">
                            Следующая глава:
                            <router-link :to="{ name: 'chapter_show', params: { id: c.next_chapter.id } }">{{ c.next_chapter.name }}</router-link>
                        </li>
                    </ul>                    
                </p>
                <router-link class="btn btn-primary" :to="{ name: 'course_show', params: { id: c.id } }">Перейти к курсу</router-link>
            </div>
            <div class="card-footer text-muted">
                <template v-if="c.last_activity">
                    Последняя активность:
                    {{ localeDate(c.last_activity) }}
                </template>
            </div>
        </div>

    </div>
</template>

<script>
import TheCoursesMenu from '@/components/TheCoursesMenu'
import PageTitle from '@/components/PageTitle'
import Loader from '@/components/Loader'
import axios from 'axios'
import QuoteTest from '@/components/QuoteTest'
export default {
    data() {
        return {
            data: [],
            title: 'Курсы',
            errors: {load: ''},
            loading: true,
        }
    },
    async mounted() {
        // загрузка данных:
        this.loadRecords()
    },
    methods: {
        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('courses/inprogress')
                this.data = response.data
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
        localeDate(d) {
            // Конвертируем число в строку. Для этого существуют специальные методы
            // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
            // Итоговая строка будет зависеть от локализации системы пользователя. 
            // Для русской локали это будет "01.02.2020", 
            // для американской "2/1/2020", 
            // для немецкой — "1.2.2020"
            // Вы НЕ должны устанавливать формат даты самостоятельно
            if (d)
                return (new Date(d)).toLocaleDateString() 
            else
                return null;
        },

    },
    components: {
        TheCoursesMenu,
        PageTitle,
        Loader,
        QuoteTest,
    }
}
</script>
<style scoped>
ul li {
    /* border: 2px solid red; */
    list-style: none; 
    background: url(/icons/arrow.png) no-repeat left 50%; 
    padding-left: 25px;
}
</style>